import QuoteSummaryList from "./QuoteSummaryList";
import QuoteSummaryTotals from "./QuoteSummaryTotals";
import ClientBasicInfo from "Components/Common/ClientBasicInfo";
import InvoicesBasicInfo from "Components/Common/InvoicesBasicInfo";
import QuoteBasicInfo from "./QuoteBasicInfo";
import { QuoteDetailsPayload } from "types/quote.api";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import React, { useEffect } from "react";
import { getInvoices } from "slices/thunks";
import { createSelector } from "reselect";
import { selectInvoicesState } from "slices/invoices/reducer";
import { Card, CardBody, Col, Row } from "reactstrap";

interface QuoteSummaryProps {
  quote: QuoteDetailsPayload;
}

const QuoteSummary: React.FC<QuoteSummaryProps> = ({ quote }) => {
  const dispatch = useAppDispatch();

  const invoiceSelector = createSelector([selectInvoicesState], (state) => ({
    invoiceItems: state.invoices,
    isLoading: state.status.fetch,
    error: state.errors.fetch,
    meta: state.pagination,
  }));

  const { invoiceItems } = useAppSelector(invoiceSelector);

  useEffect(() => {
    if (quote) {
      dispatch(getInvoices({ quote_id: quote.id }));
    }
  }, [quote]);

  return (
    <Row className="g-3 w-100">
      {/* LEFT SECTION */}
      <Col xl={9} lg={8} className="d-flex flex-column">
        <Card className="br-10 bg-white">
          <CardBody>
            <div className="bg-white br-10 flex-grow-1">
              <QuoteSummaryList quoteDetails={quote} />
              <QuoteSummaryTotals quotesDetails={quote} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* RIGHT SIDEBAR */}
      <Col xl={3} lg={4}>
        <div className="d-flex flex-column gap-3">
          <QuoteBasicInfo quote={quote} />
          <ClientBasicInfo client={quote.client} />
          {invoiceItems.length > 0 && (
            <InvoicesBasicInfo inVoices={invoiceItems} />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default React.memo(QuoteSummary);
